import React from "react";
import { Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import DropdownComponent from "./DropdownComponent";
import BasicThemeJson from "./ThemePropertiesJson/BasicThemeJson";
import { useTranslation } from "react-i18next";

const StyleComponent = (props) => {
  const { t } = useTranslation();
  const stylingProperties = props.stylingProperties;
  return (
    <div className={style.stylingComponent}>
      {stylingProperties && stylingProperties.heading ? (
        <Col className={[style.layoutSubHeader].join(" ")}>
          {t(`${stylingProperties.heading}`)}{" "}
        </Col>
      ) : null}
      {stylingProperties && stylingProperties.children ? (
        <div>
          {stylingProperties.children.map((details, index) => {
            if (
              props.selectedTheme.InputStyle.LabelValueAlignment ===
                "Top Bottom" &&
              details.key === "LabelRatio"
            ) {
              return;
            }
            return (
              <DropdownComponent
                propertyDetails={details}
                selectedControl={props.selectedControl}
                propertyName={details.key}
                selectedOption={
                  props.selectedTheme &&
                  props.themeKey &&
                  props.selectedTheme[props.themeKey] &&
                  details &&
                  details.key &&
                  props.selectedTheme[props.themeKey][details.key]
                    ? props.selectedTheme[props.themeKey][details.key]
                    : details &&
                      details.key &&
                      details.key.includes("FontFamily") === true
                    ? props.selectedTheme["BasicTheme"] &&
                      props.selectedTheme["BasicTheme"]["FontFamily"]
                    : details &&
                      details.key &&
                      details.key.includes("FontSize") === true
                    ? props.selectedTheme["BasicTheme"] &&
                      props.selectedTheme["BasicTheme"]["FontSize"]
                    : details &&
                      details.key &&
                      details.key.includes("FontColor") === true
                    ? props.selectedTheme["BasicTheme"] &&
                      props.selectedTheme["BasicTheme"]["FontColor"]
                    : ""
                }
                presetColors={
                  props.selectedTheme["BasicTheme"] &&
                  props.selectedTheme["BasicTheme"]["PresetColors"]
                    ? props.selectedTheme["BasicTheme"]["PresetColors"]
                    : BasicThemeJson["PresetColors"]
                }
                handleProperty={(arg1, arg2) =>
                  props.handleProperty(arg1, arg2)
                }
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default StyleComponent;
